import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import cn from "clsx";
import { Icon } from "../icon";

export type TagProps = {
  asChild?: boolean;
  content: string;
  iconName?: string;
} & React.ButtonHTMLAttributes<HTMLDivElement>;

const Tag = React.forwardRef<HTMLDivElement, TagProps>(
  ({ className, asChild = false, content, iconName, ...props }, ref) => {
    const Comp = asChild ? Slot : "div";
    return (
      <Comp ref={ref} className={cn("in-tag", className)} {...props}>
        {iconName && (<Icon prefix="fasr" iconName={iconName} />)}<span className={cn("in-tag__text")}>{content}</span>
      </Comp>
    );
  }
);

export { Tag };
